import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Recommendation } from '../dto/recommendation';
import { RecomWithTestAndStep } from '../dto/recom-with-test-and-step';

@Injectable({
  providedIn: 'root'
})
export class RecommendationService {

  private apiUrl = environment.apiRoot + '/recommendation';

  constructor(private http: HttpClient) { }

  getAllRecommendationOfTrail(trailId: number): Observable<Recommendation[]> {
    return this.http.get<Recommendation[]>(this.apiUrl + '/alloftrail?trailId=' + trailId);
  }

  getAllRecomWithTestAndStepOfTrial(trialId: number): Observable<RecomWithTestAndStep[]> {
    return this.http.get<RecomWithTestAndStep[]>(this.apiUrl + '/allRecomOfTrial?trialId=' + trialId);
  }

  getAllRecommendationOfTest(testId: number): Observable<Recommendation[]> {
    return this.http.get<Recommendation[]>(this.apiUrl + '/alloftest?testId=' + testId);
  }

  createRecommendation(testId: number): Observable<Recommendation> {
    let model = { "id": 0, "test_id": testId, "sn": "new rec." };
    return this.http.post<Recommendation>(this.apiUrl + '/new', model);
  }

  updateRecommendation(model: Recommendation): Observable<Recommendation> {
    return this.http.put<Recommendation>(this.apiUrl + '/update', model);
  }

  deleteRecommendation(recommendationId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?recommendationId=' + recommendationId);
  }
}
